<!-- 称重记录 -->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/tool/weight/record/page" getKey="rows" :columns="columns">
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
export default {
  components: {},
  name: "web_base_tool_tool_weight_record",
  data() {
    return {
      columns: [
        {
          label: "chengzhongshijian",
          prop: "createTime",
          type: "time",
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "chengzhongren",
          prop: "createByObject.nickname",
        },
        {
          label: "gengxinqianjilu",
          prop: "weightBefore",
        },
        {
          label: "gengxinhoujilu",
          prop: "weightAfter",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      // table列表接口请求参数
      this.yt.conditions = {
        toolId: this.$attrs.toolRecord.id,
        pageSize: 10,
        orderBy: "createTime desc",
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.shift {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
</style>
